<div class="loading-dialog">
  <rds-progress-spinner [label]="data.message"></rds-progress-spinner>
  @if (data.instruction) {
  <p class="ui-body-m-bold instruction">{{ data.instruction }}</p>
  }
</div>
